import { FilterBuilder } from '../Types';

const isSearchableBuilder: FilterBuilder = () => 'isSearchable:true';

export { isSearchableBuilder };
